import { makeApiRequest } from 'actions/api';
import { undoBasketEdits } from 'actions/basketEdits';
import { refreshBehavioralDiscounts } from 'actions/behavioralDiscounts';
import { getMenu } from 'actions/menus';
import { getSuggestedPairings } from 'actions/suggestedPairings';
import { undoBasketEdits as undoV3BasketEdits } from 'actions/v3/basketEdits';
import { getBasketSummary as getV3BasketSummary } from 'actions/v3/baskets';
import { getMenu as getV3Menu } from 'actions/v3/menus';
import * as fromDashboard from 'reducers/dashboard';
import RequestService from 'services/RequestService';

export const GET_BASKET = 'GET_BASKET';
export const GET_BASKET_REQUEST = 'GET_BASKET_REQUEST';
export const GET_BASKET_RESPONSE = 'GET_BASKET_RESPONSE';
export const GET_BASKET_ERROR = 'GET_BASKET_ERROR';

export const GET_BASKET_SUMMARIES = 'GET_BASKET_SUMMARIES';
export const GET_BASKET_SUMMARIES_REQUEST = 'GET_BASKET_SUMMARIES_REQUEST';
export const GET_BASKET_SUMMARIES_RESPONSE = 'GET_BASKET_SUMMARIES_RESPONSE';
export const GET_BASKET_SUMMARIES_ERROR = 'GET_BASKET_SUMMARIES_ERROR';

export const SKIP_BASKET = 'SKIP_BASKET';
export const SKIP_BASKET_REQUEST = 'SKIP_BASKET_REQUEST';
export const SKIP_BASKET_RESPONSE = 'SKIP_BASKET_RESPONSE';
export const SKIP_BASKET_ERROR = 'SKIP_BASKET_ERROR';

export const UNSKIP_BASKET = 'UNSKIP_BASKET';
export const UNSKIP_BASKET_REQUEST = 'UNSKIP_BASKET_REQUEST';
export const UNSKIP_BASKET_RESPONSE = 'UNSKIP_BASKET_RESPONSE';
export const UNSKIP_BASKET_ERROR = 'UNSKIP_BASKET_ERROR';

export const ADD_BASKET = 'ADD_BASKET';
export const ADD_BASKET_REQUEST = 'ADD_BASKET_REQUEST';
export const ADD_BASKET_RESPONSE = 'ADD_BASKET_RESPONSE';
export const ADD_BASKET_ERROR = 'ADD_BASKET_ERROR';

export const UPDATE_BASKET = 'UPDATE_BASKET';
export const UPDATE_BASKET_REQUEST = 'UPDATE_BASKET_REQUEST';
export const UPDATE_BASKET_RESPONSE = 'UPDATE_BASKET_RESPONSE';
export const UPDATE_BASKET_ERROR = 'UPDATE_BASKET_ERROR';
export const UPDATE_BASKET_ADDRESS = 'UPDATE_BASKET_ADDRESS';
export const UPDATE_BASKET_ADDRESS_RESPONSE = 'UPDATE_BASKET_ADDRESS_RESPONSE';
export const CLEAR_BASKET_ADDRESS = 'CLEAR_BASKET_ADDRESS';

export const DONATE_BASKET = 'DONATE_BASKET';
export const DONATE_BASKET_REQUEST = 'DONATE_BASKET_REQUEST';
export const DONATE_BASKET_RESPONSE = 'DONATE_BASKET_RESPONSE';
export const DONATE_BASKET_ERROR = 'DONATE_BASKET_ERROR';

export const GET_RECEIPT = 'GET_RECEIPT';
export const GET_RECEIPT_REQUEST = 'GET_RECEIPT_REQUEST';
export const GET_RECEIPT_RESPONSE = 'GET_RECEIPT_RESPONSE';
export const GET_RECEIPT_ERROR = 'GET_RECEIPT_ERROR';

export const GET_NUTRITION_SUMMARY = 'GET_NUTRITION_SUMMARY';
export const GET_NUTRITION_SUMMARY_REQUEST = 'GET_NUTRITION_SUMMARY_REQUEST';
export const GET_NUTRITION_SUMMARY_RESPONSE = 'GET_NUTRITION_SUMMARY_RESPONSE';
export const GET_NUTRITION_SUMMARY_ERROR = 'GET_NUTRITION_SUMMARY_ERROR';

export const GET_TRACKING = 'GET_TRACKING';
export const GET_TRACKING_REQUEST = 'GET_TRACKING_REQUEST';
export const GET_TRACKING_RESPONSE = 'GET_TRACKING_RESPONSE';
export const GET_TRACKING_ERROR = 'GET_TRACKING_ERROR';

export const UNDONATE_BASKET = 'UNDONATE_BASKET';
export const UNDONATE_BASKET_REQUEST = 'UNDONATE_BASKET_REQUEST';
export const UNDONATE_BASKET_RESPONSE = 'UNDONATE_BASKET_RESPONSE';
export const UNDONATE_BASKET_ERROR = 'UNDONATE_BASKET_ERROR';

export const GET_PROJECTED_COSTS = 'GET_PROJECTED_COSTS';
export const GET_PROJECTED_COSTS_REQUEST = 'GET_PROJECTED_COSTS_REQUEST';
export const GET_PROJECTED_COSTS_RESPONSE = 'GET_PROJECTED_COSTS_RESPONSE';
export const GET_PROJECTED_COSTS_ERROR = 'GET_PROJECTED_COSTS_ERROR';

export const GET_TIERED_PRICING_DETAILS = 'GET_TIERED_PRICING_DETAILS';
export const GET_TIERED_PRICING_DETAILS_REQUEST = 'GET_TIERED_PRICING_DETAILS_REQUEST';
export const GET_TIERED_PRICING_DETAILS_RESPONSE = 'GET_TIERED_PRICING_DETAILS_RESPONSE';
export const GET_TIERED_PRICING_DETAILS_ERROR = 'GET_TIERED_PRICING_DETAILS_ERROR';

export const skipBasket = (menuSlug, cta) => {
  return async dispatch => {
    const response = await dispatch(
      makeApiRequest({
        requestType: SKIP_BASKET,
        method: RequestService.skipBasket,
        params: { menuSlug },
        metadata: { cta },
      })
    );
    if (response.ok) {
      dispatch(refreshBehavioralDiscounts(menuSlug));
      dispatch(refreshBaskets(menuSlug));
    }
    return response;
  };
};

export const unskipBasket = (
  menuSlug,
  cta,
  isUnskipViaSlideout = false,
  mealId = null,
  mealOptionIds = []
) => {
  return async dispatch => {
    const params = { menuSlug, mealId, cta, isUnskipViaSlideout, mealOptionIds };
    const response = await dispatch(
      makeApiRequest({
        requestType: UNSKIP_BASKET,
        method: RequestService.unskipBasket,
        params,
        metadata: { cta },
      })
    );
    if (response.ok) {
      if (isUnskipViaSlideout) {
        await dispatch(getV3BasketSummary(menuSlug));
      }
      dispatch(refreshBehavioralDiscounts(menuSlug));
      dispatch(refreshBaskets(menuSlug));
    }
    return response;
  };
};

export const getBasket = menuSlug =>
  makeApiRequest({
    requestType: GET_BASKET,
    method: RequestService.getBasket,
    params: { menuSlug },
  });

export const donateBasket = (menuSlug, servings, cta) =>
  makeApiRequest({
    requestType: DONATE_BASKET,
    method: RequestService.donateBasket,
    params: { menuSlug, servings },
    metadata: { cta },
  });

export const getBasketSummaries = (offset = -1, limit = 6) =>
  makeApiRequest({
    requestType: GET_BASKET_SUMMARIES,
    method: RequestService.getBasketSummaries,
    params: { limit, offset },
  });

export const updateBasket = (menuSlug, params) =>
  makeApiRequest({
    requestType: UPDATE_BASKET,
    method: RequestService.updateBasket,
    params: { menuSlug, bypassReviewPrompt: true, ...params },
  });

export const undonateBasket = (menuSlug, cta) =>
  makeApiRequest({
    requestType: UNDONATE_BASKET,
    method: RequestService.undonateBasket,
    params: { menuSlug },
    metadata: { cta },
  });

export const addBasket = (menuSlug, params) =>
  makeApiRequest({
    requestType: ADD_BASKET,
    method: RequestService.addBasket,
    params: { menuSlug, ...params },
  });

export const updateBasketAddress = ({ menuSlug, addressId, isDefault, isTwoStage }) => {
  return async dispatch => {
    const response = await dispatch(
      makeApiRequest({
        requestType: UPDATE_BASKET_ADDRESS,
        method: RequestService.updateBasketAddress,
        params: { menuSlug, address: { id: addressId } },
        metadata: {
          default: isDefault,
        },
      })
    );

    if (response.ok) {
      if (isTwoStage) {
        dispatch(getV3Menu(menuSlug));
      } else {
        dispatch(getMenu(menuSlug));
      }

      const suggestedPairingsResponse = await dispatch(getSuggestedPairings(menuSlug));
      const selectedPairings =
        (suggestedPairingsResponse.suggestedPairings &&
          suggestedPairingsResponse.suggestedPairings.filter(
            pairing => pairing.suggestedPairing.isSelected === true
          )) ||
        [];

      if (isTwoStage) {
        dispatch(
          undoV3BasketEdits({ basket: response.weeklyBasket, selectedPairings: selectedPairings })
        );
      } else {
        dispatch(
          undoBasketEdits({ basket: response.weeklyBasket, selectedPairings: selectedPairings })
        );
      }
    }
    return response;
  };
};

export const refreshBaskets = menuSlug => async (dispatch, getState) => {
  const state = getState();
  const menuSlugs = fromDashboard.selectMenuSlugs(state);
  const menusToFetch = menuSlugs.slice(menuSlugs.indexOf(menuSlug) + 1);
  const filteredMenusToFetch = menusToFetch.filter(slug => {
    const basket = fromDashboard.selectBasket(state, slug);
    // deliveryDay is non-existent on unloaded baskets
    return basket.deliveryDay;
  });

  return await Promise.all(
    filteredMenusToFetch.map(menuSlug => dispatch(getV3BasketSummary(menuSlug)))
  );
};

export const getReceipt = params =>
  makeApiRequest({
    requestType: GET_RECEIPT,
    method: RequestService.getReceipt,
    params,
  });

export const getNutritionSummary = params =>
  makeApiRequest({
    requestType: GET_NUTRITION_SUMMARY,
    method: RequestService.getNutritionSummary,
    params,
  });

export const getTracking = menuSlug =>
  makeApiRequest({
    requestType: GET_TRACKING,
    method: RequestService.getTracking,
    params: { menuSlug },
  });

export const getProjectedCosts = weeklyBasket => {
  return async dispatch => {
    const response = await dispatch(
      makeApiRequest({
        requestType: GET_PROJECTED_COSTS,
        method: RequestService.getProjectedCosts,
        params: { weeklyBasket },
      })
    );

    return response;
  };
};

export const getTieredPricingDetails = mealPricePlanId =>
  makeApiRequest({
    requestType: GET_TIERED_PRICING_DETAILS,
    method: RequestService.getTieredPricingDetails,
    params: { id: mealPricePlanId },
  });
